import type { CardProvider } from '@atlaskit/editor-common/provider-factory/card-provider';
import type { PastePluginOptions } from '@atlaskit/editor-plugin-paste/paste-plugin-type';
import { markdownToAdf } from '@atlassian/markdown-support/markdown-conversion';

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */
const SMART_LINKS_BEFORE_MACROS =
	'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
// END SECTION

interface Props {
	options: never;
	providers: {
		cardProvider: Promise<CardProvider> | undefined;
	};
}

/**
 * Builds paste plugin options for Confluence full-page preset.
 * Injects the GFM markdown converter used for Cmd+V plain-text paste.
 */
export function pastePluginOptions({ providers }: Props): PastePluginOptions {
	return {
		cardOptions: {
			provider: providers.cardProvider,
			// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
			allowBlockCards: true,
			allowDatasource: true,
			allowEmbeds: true,
			resolveBeforeMacros: SMART_LINKS_BEFORE_MACROS,
			// END SECTION
		},
		sanitizePrivateContent: true,
		isFullPage: true,
		markdownToPmConverter: ({ markdown, schema }) => markdownToAdf(markdown, schema).content,
	};
}
